// src/RecipeModal.js
import React, { useState } from 'react';
import RNGChart from './components/RNGChart';

export default function RecipeModal({
    recipe,
    selectedNFTs,
    onClose,
    onConfirm,
    onDone      // ← new prop
}) {
    const [status, setStatus] = useState('confirm');
    const [result, setResult] = useState(null);

    const handleConfirm = async () => {
        setStatus('upgrading');
        try {
            const result = await onConfirm();
            // console.log('🔍 DEBUG: RecipeModal received result:', result);
            setResult(result);
            setStatus('complete');
        } catch {
            onClose();
        }
    };

    const handleCancel = async () => {
        // Log user cancellation for recipe
        try {
            await fetch(
                `${process.env.REACT_APP_API_URL}/api/nft?` +
                new URLSearchParams({ action: 'log-upgrade-failure' }),
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        wallet: window.ethereum?.selectedAddress,
                        upgrade_type: recipe.recipe_type === 'free_mint' ? 'free_mint_upgrade' : 
                                      recipe.recipe_type === 'token_gated' ? 'token_gated_upgrade' : 'recipe_upgrade',
                        original_nfts: (selectedNFTs || []).map(nft => ({
                            collection: nft.collection,
                            tokenId: nft.tokenId.toString()
                        })),
                        target_recipe: recipe.title,
                        error_message: 'User cancelled recipe crafting',
                        error_stage: 'user_cancellation',
                        user_agent: navigator.userAgent
                    })
                }
            );
        } catch (logError) {
            console.error('Failed to log recipe cancellation:', logError);
        }
        
        onClose();
    };

    const handleOkay = () => {
        if (typeof onDone === 'function') {
            onDone();
        } else {
            onClose();
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">

                {status === 'confirm' && (
                    <>
                        <h2>
                          {recipe.recipe_type === 'free_mint' ? 'Free Mint:' : 'Craft:'} {recipe.title}
                        </h2>
                        
                        {recipe.recipe_type === 'free_mint' ? (
                          <div style={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <p>
                              You're about to mint {recipe.title} for free! No NFTs will be burned.
                            </p>
                            <p style={{ 
                              fontSize: '0.9rem', 
                              color: '#ffa500', 
                              fontStyle: 'italic',
                              backgroundColor: 'rgba(255, 165, 0, 0.1)',
                              padding: '0.5rem',
                              borderRadius: '4px',
                              border: '1px solid rgba(255, 165, 0, 0.3)',
                              margin: '1rem 0'
                            }}>
                              ⚠️ You will be asked to sign a message to verify your wallet and prevent spam.
                            </p>

                            {/* Show possible rewards with images and chances */}
                            <div style={{ 
                              width: '100%',
                              maxWidth: '500px',
                              marginBottom: '1.5rem'
                            }}>
                              <h3 style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
                                {recipe.rng_enabled ? 'Possible Rewards:' : 'Item You\'re Minting:'}
                              </h3>
                              {recipe.rng_enabled && recipe.rewards.length >= 4 ? (
                                // Special 4+ item layout with proper OR positioning
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                  {/* Top row */}
                                  <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', gap: '0.5rem' }}>
                                    <div style={{
                                      padding: '0.75rem',
                                      backgroundColor: 'rgba(138, 43, 226, 0.1)',
                                      borderRadius: '8px',
                                      border: '1px solid rgba(138, 43, 226, 0.3)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      flex: 1,
                                      maxWidth: '140px',
                                      textAlign: 'center'
                                    }}>
                                      {recipe.rewards[0].image && (
                                        <img
                                          src={recipe.rewards[0].image}
                                          alt={recipe.rewards[0].name}
                                          style={{
                                            width: '70px',
                                            height: '70px',
                                            objectFit: 'contain',
                                            marginBottom: '0.5rem'
                                          }}
                                        />
                                      )}
                                      <div style={{ fontSize: '0.9rem', color: '#fff', fontWeight: 'bold', marginBottom: '0.3rem' }}>
                                        {recipe.rewards[0].name}
                                      </div>
                                      <div style={{ 
                                        fontSize: '0.65rem', 
                                        color: '#fff',
                                        background: 'rgb(255, 107, 107)',
                                        padding: '0.25rem 0.5rem',
                                        borderRadius: '0.6rem',
                                        fontWeight: 'bold'
                                      }}>
                                        🎲 {recipe.rewards[0].chance}% chance
                                      </div>
                                    </div>
                                    
                                    <div style={{
                                      fontSize: '1rem',
                                      fontWeight: 'bold',
                                      color: '#fff',
                                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                      margin: '0 0.5rem'
                                    }}>
                                      OR
                                    </div>
                                    
                                    <div style={{
                                      padding: '0.75rem',
                                      backgroundColor: 'rgba(138, 43, 226, 0.1)',
                                      borderRadius: '8px',
                                      border: '1px solid rgba(138, 43, 226, 0.3)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      flex: 1,
                                      maxWidth: '140px',
                                      textAlign: 'center'
                                    }}>
                                      {recipe.rewards[1].image && (
                                        <img
                                          src={recipe.rewards[1].image}
                                          alt={recipe.rewards[1].name}
                                          style={{
                                            width: '70px',
                                            height: '70px',
                                            objectFit: 'contain',
                                            marginBottom: '0.5rem'
                                          }}
                                        />
                                      )}
                                      <div style={{ fontSize: '0.9rem', color: '#fff', fontWeight: 'bold', marginBottom: '0.3rem' }}>
                                        {recipe.rewards[1].name}
                                      </div>
                                      <div style={{ 
                                        fontSize: '0.65rem', 
                                        color: '#fff',
                                        background: 'rgb(255, 107, 107)',
                                        padding: '0.25rem 0.5rem',
                                        borderRadius: '0.6rem',
                                        fontWeight: 'bold'
                                      }}>
                                        🎲 {recipe.rewards[1].chance}% chance
                                      </div>
                                    </div>
                                  </div>
                                  
                                  {/* Middle OR row */}
                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ flex: 1, textAlign: 'center' }}>
                                      <div style={{
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        color: '#fff',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                                      }}>
                                        OR
                                      </div>
                                    </div>
                                    <div style={{ flex: 1, textAlign: 'center' }}>
                                      <div style={{
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        color: '#fff',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                                      }}>
                                        OR
                                      </div>
                                    </div>
                                  </div>
                                  
                                  {/* Bottom row */}
                                  <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', gap: '0.5rem' }}>
                                    <div style={{
                                      padding: '0.75rem',
                                      backgroundColor: 'rgba(138, 43, 226, 0.1)',
                                      borderRadius: '8px',
                                      border: '1px solid rgba(138, 43, 226, 0.3)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      flex: 1,
                                      maxWidth: '140px',
                                      textAlign: 'center'
                                    }}>
                                      {recipe.rewards[2].image && (
                                        <img
                                          src={recipe.rewards[2].image}
                                          alt={recipe.rewards[2].name}
                                          style={{
                                            width: '70px',
                                            height: '70px',
                                            objectFit: 'contain',
                                            marginBottom: '0.5rem'
                                          }}
                                        />
                                      )}
                                      <div style={{ fontSize: '0.9rem', color: '#fff', fontWeight: 'bold', marginBottom: '0.3rem' }}>
                                        {recipe.rewards[2].name}
                                      </div>
                                      <div style={{ 
                                        fontSize: '0.65rem', 
                                        color: '#fff',
                                        background: 'rgb(255, 107, 107)',
                                        padding: '0.25rem 0.5rem',
                                        borderRadius: '0.6rem',
                                        fontWeight: 'bold'
                                      }}>
                                        🎲 {recipe.rewards[2].chance}% chance
                                      </div>
                                    </div>
                                    
                                    <div style={{
                                      fontSize: '1rem',
                                      fontWeight: 'bold',
                                      color: '#fff',
                                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                      margin: '0 0.5rem'
                                    }}>
                                      OR
                                    </div>
                                    
                                    <div style={{
                                      padding: '0.75rem',
                                      backgroundColor: 'rgba(138, 43, 226, 0.1)',
                                      borderRadius: '8px',
                                      border: '1px solid rgba(138, 43, 226, 0.3)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      flex: 1,
                                      maxWidth: '140px',
                                      textAlign: 'center'
                                    }}>
                                      {recipe.rewards[3].image && (
                                        <img
                                          src={recipe.rewards[3].image}
                                          alt={recipe.rewards[3].name}
                                          style={{
                                            width: '70px',
                                            height: '70px',
                                            objectFit: 'contain',
                                            marginBottom: '0.5rem'
                                          }}
                                        />
                                      )}
                                      <div style={{ fontSize: '0.9rem', color: '#fff', fontWeight: 'bold', marginBottom: '0.3rem' }}>
                                        {recipe.rewards[3].name}
                                      </div>
                                      <div style={{ 
                                        fontSize: '0.65rem', 
                                        color: '#fff',
                                        background: 'rgb(255, 107, 107)',
                                        padding: '0.25rem 0.5rem',
                                        borderRadius: '0.6rem',
                                        fontWeight: 'bold'
                                      }}>
                                        🎲 {recipe.rewards[3].chance}% chance
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                // Regular layout for 1-3 items
                                <div style={{ 
                                  display: 'flex',
                                  flexDirection: 'row',
                                  flexWrap: 'wrap',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: recipe.rng_enabled ? '0.5rem' : '0.75rem',
                                  maxWidth: '100%'
                                }}>
                                  {recipe.rewards.map((reward, index) => (
                                    <React.Fragment key={index}>
                                      <div style={{
                                        padding: '0.75rem',
                                        backgroundColor: 'rgba(138, 43, 226, 0.1)',
                                        borderRadius: '8px',
                                        border: '1px solid rgba(138, 43, 226, 0.3)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        minWidth: '150px',
                                        maxWidth: '200px'
                                      }}>
                                        {reward.image && (
                                          <img
                                            src={reward.image}
                                            alt={reward.name || `Reward ${index + 1}`}
                                            style={{
                                              width: '80px',
                                              height: '80px',
                                              objectFit: 'contain',
                                              marginBottom: '0.5rem'
                                            }}
                                          />
                                        )}
                                        <div style={{ 
                                          fontSize: '0.85rem', 
                                          color: '#fff',
                                          textAlign: 'center',
                                          fontWeight: 'bold'
                                        }}>
                                          {reward.name || `Reward ${index + 1}`}
                                        </div>
                                        {recipe.rng_enabled && reward.chance && (
                                          <div style={{ 
                                            fontSize: '0.75rem', 
                                            color: '#fff',
                                            marginTop: '0.25rem',
                                            background: 'rgb(255, 107, 107)',
                                            padding: '0.25rem 0.5rem',
                                            borderRadius: '1rem',
                                            textAlign: 'center',
                                            fontWeight: 'bold'
                                          }}
                                          title={`${reward.chance}% chance to receive this reward`}>
                                            🎲 {reward.chance}% chance
                                          </div>
                                        )}
                                      </div>
                                      {recipe.rng_enabled && index < recipe.rewards.length - 1 && (
                                        <div style={{
                                          fontSize: '1.2rem',
                                          fontWeight: 'bold',
                                          color: '#fff',
                                          textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                          margin: '0 0.25rem',
                                          flexShrink: 0
                                        }}>
                                          OR
                                        </div>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <>
                            <p>
                              You're about to burn the following {selectedNFTs.length} NFT
                              {selectedNFTs.length > 1 ? 's' : ''}:
                            </p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: '1rem 0' }}>
                              {selectedNFTs.map(nft => {
                                  // find the matching recipe.requires entry to pull name+icon
                                  const req = recipe.requires?.find(r =>
                                      r.collection.toLowerCase() === nft.collection.toLowerCase()
                                  ) || {};
                                  const label = req.name || nft.title || nft.collection;
                                  const icon = req.image;
                                  return (
                                      <li
                                          key={`${nft.collection}-${nft.tokenId}`}
                                          style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              margin: '0.5rem 0'
                                          }}
                                      >
                                          {icon && (
                                              <img
                                                  src={icon}
                                                  alt={label}
                                                  style={{
                                                      width: '32px',
                                                      height: '32px',
                                                      objectFit: 'contain',
                                                      marginRight: '8px',
                                                      borderRadius: '4px'
                                                  }}
                                              />
                                          )}
                                          <span>
                                              {label} — Token <strong>{nft.tokenId}</strong>
                                          </span>
                                      </li>
                                  );
                              })}
                            </ul>
                            <p>
                              You will be required to confirm a signature for each item before mint is processed. Please watch your MetaMask for signature requests.
                            </p>

                            {/* Show possible rewards with images and chances */}
                            <div style={{ 
                              marginTop: '1.5rem',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center'
                            }}>
                              <h3 style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
                                {recipe.rng_enabled ? 'Possible Rewards:' : 'Item You\'re Minting:'}
                              </h3>
                              <div style={{ 
                                display: 'flex', 
                                flexDirection: recipe.rng_enabled ? 'row' : 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: recipe.rng_enabled ? '1rem' : '0.75rem',
                                marginBottom: '1.5rem',
                                width: '100%',
                                maxWidth: '500px',
                                flexWrap: 'wrap'
                              }}>
                                {recipe.rewards.map((reward, index) => (
                                  <React.Fragment key={index}>
                                    <div style={{
                                      padding: '0.75rem',
                                      backgroundColor: 'rgba(138, 43, 226, 0.1)',
                                      borderRadius: '8px',
                                      border: '1px solid rgba(138, 43, 226, 0.3)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      minWidth: '150px',
                                      maxWidth: '200px'
                                    }}>
                                      {reward.image && (
                                        <img
                                          src={reward.image}
                                          alt={reward.name || `Reward ${index + 1}`}
                                          style={{
                                            width: '80px',
                                            height: '80px',
                                            objectFit: 'contain',
                                            borderRadius: '8px',
                                            marginBottom: '0.5rem'
                                          }}
                                        />
                                      )}
                                      <div style={{ 
                                        fontSize: '0.85rem', 
                                        color: '#fff',
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                      }}>
                                        {reward.name || `Reward ${index + 1}`}
                                      </div>
                                      {recipe.rng_enabled && reward.chance !== undefined && (
                                        <div style={{ 
                                          fontSize: '0.75rem', 
                                          color: '#fff',
                                          marginTop: '0.25rem',
                                          background: 'rgb(255, 107, 107)',
                                          padding: '0.25rem 0.5rem',
                                          borderRadius: '1rem',
                                          textAlign: 'center',
                                          fontWeight: 'bold'
                                        }}>
                                          🎲 {reward.chance}% chance
                                        </div>
                                      )}
                                    </div>
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                          </>
                        )}

                        <div style={{ 
                          display: 'flex', 
                          gap: '1rem', 
                          marginTop: '1.5rem',
                          justifyContent: 'center'
                        }}>
                            <button 
                              className="no-btn" 
                              onClick={handleCancel}
                              style={{
                                fontSize: '1rem',
                                padding: '0.75rem 1.5rem',
                                minWidth: '120px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase'
                              }}
                            >
                                CANCEL
                            </button>
                            <button 
                              className="rainbowBtn" 
                              onClick={handleConfirm}
                              style={{
                                fontSize: '1rem',
                                padding: '0.75rem 1.5rem',
                                minWidth: '120px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase'
                              }}
                            >
                                {recipe.recipe_type === 'free_mint' ? 'FREE MINT' : 'CRAFT'}
                            </button>
                        </div>
                    </>
                )}

                {status === 'upgrading' && (
                    <>
                        <h2>⏳ {recipe.recipe_type === 'free_mint' ? 'Minting' : 'Crafting'} your {recipe.title}…</h2>
                        <div className="loading-spinner">Processing...</div>
                    </>
                )}

                {status === 'complete' && (
                    <div style={{ textAlign: 'center' }}>
                        <h2 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>
                          {recipe.recipe_type === 'free_mint' ? 'Free Mint Complete!' : 'Craft Complete!'}
                        </h2>
                        
                        {/* RNG Chart for RNG-enabled recipes */}
                        {recipe.rng_enabled && result?.random_value && result?.rng_pool && result?.minted_item && (
                          <RNGChart
                            randomValue={result.random_value}
                            rewards={result.rng_pool}
                            selectedReward={result.minted_item}
                            totalChance={result.rng_pool.reduce((sum, r) => sum + (Number(r.chance) || 0), 0)}
                            style={{ marginBottom: '2rem' }}
                          />
                        )}
                        
                        
                        
                        {result && (
                          <div style={{
                            marginBottom: '1rem',
                            padding: '1rem',
                            background: 'rgba(138, 43, 226, 0.1)',
                            border: '1px solid rgba(138, 43, 226, 0.3)',
                            borderRadius: '0.75rem',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '0.75rem'
                          }}>
                            {recipe.rng_enabled ? (
                              // Simplified display for RNG recipes
                              <div style={{ textAlign: 'center' }}>
                                <p style={{ marginBottom: '0.2rem', fontSize: '0.9rem', color: '#ccc' }}>
                                  Collection: {result.minted_item?.collection || result.collection}
                                </p>
                                <p style={{ marginBottom: '0.3rem', fontSize: '0.9rem', color: '#ccc' }}>
                                  Token ID: {result.minted_item?.token_id || result.token_id}
                                </p>
                              </div>
                            ) : (
                              // Full display for non-RNG recipes
                              <>
                                <img 
                                  src={result.minted_item?.image || result.image} 
                                  alt={result.minted_item?.name || result.name}
                                  style={{
                                    width: '150px',
                                    height: '150px',
                                    objectFit: 'contain',
                                    borderRadius: '0.5rem'
                                  }}
                                />
                                <div style={{ textAlign: 'center' }}>
                                  <h3 style={{ 
                                    fontSize: '1.2rem', 
                                    fontWeight: 'bold',
                                    marginBottom: '0.5rem',
                                    color: '#8a2be2'
                                  }}>
                                    {result.minted_item?.name || result.name}
                                  </h3>
                                  <p style={{ marginBottom: '0.25rem' }}>
                                    Collection: {result.minted_item?.collection || result.collection}
                                  </p>
                                  <p style={{ marginBottom: '0.5rem' }}>
                                    Token ID: {result.minted_item?.token_id || result.token_id}
                                  </p>
                                </div>
                              </>
                            )}

                            {/* Transaction Links Section */}
                            <div style={{ 
                              width: '100%', 
                              borderTop: '1px solid rgba(138, 43, 226, 0.3)', 
                              paddingTop: '0.75rem',
                              marginTop: '0.75rem'
                            }}>
                                {/* Burn Transaction Links */}
                                {result.minted_item?.burn_tx_hashes && result.minted_item.burn_tx_hashes.length > 0 && (
                                  <div style={{ marginBottom: '0.75rem' }}>
                                    <strong style={{ color: '#ff6b6b', fontSize: '0.9rem' }}>Burn Transaction{result.minted_item.burn_tx_hashes.length > 1 ? 's' : ''}:</strong>
                                    <div style={{ marginTop: '0.3rem' }}>
                                      {result.minted_item.burn_tx_hashes.map((txHash, index) => (
                                        <div key={txHash} style={{ marginBottom: '0.25rem' }}>
                                          {result.minted_item.burn_tx_hashes.length > 1 && (
                                            <span style={{ fontSize: '0.9rem', color: '#ccc' }}>
                                              Token {result.minted_item.burn_token_ids?.[index] || index + 1}:{' '}
                                            </span>
                                          )}
                                          <a
                                            href={`https://polygonscan.com/tx/${txHash}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              color: '#ff6b6b',
                                              textDecoration: 'underline',
                                              fontSize: '0.9rem'
                                            }}
                                          >
                                            View Burn on PolygonScan
                                          </a>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}

                                {/* Mint Transaction Link */}
                                {(result.minted_item?.tx_hash || result.tx_hash) && (
                                  <div>
                                    <strong style={{ color: '#22c55e', fontSize: '0.9rem' }}>Mint Transaction:</strong>
                                    <div style={{ marginTop: '0.3rem' }}>
                                      <a
                                        href={`https://polygonscan.com/tx/${result.minted_item?.tx_hash || result.tx_hash}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: '#22c55e',
                                          textDecoration: 'none',
                                          display: 'inline-block',
                                          padding: '0.5rem 1rem',
                                          border: '1px solid rgba(34, 197, 94, 0.3)',
                                          borderRadius: '0.5rem',
                                          transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.background = 'rgba(34, 197, 94, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.background = 'transparent';
                                        }}
                                      >
                                        View Mint on PolygonScan
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        )}

                        <button 
                          className="rainbowBtn" 
                          onClick={handleOkay}
                          style={{
                            fontSize: '1rem',
                            padding: '0.6rem 1.5rem'
                          }}
                        >
                          AWESOME
                        </button>
                    </div>
                )}

            </div>
        </div>
    );
}
